export interface Calculation {
    calculation_id: number;
    measurement_concept_id: number;
    name: string;
    type_of_data: string;
    description: string;
    how_to_use: string;
    when_to_use: string;
    why_use_it: string;
    interpretation: string;
    formula: string;
    input_fields: string;
    english_definition: string;
    evidence: string;
    sql_query: string;
    test_cases: string;
    guardrails: string;
    package: string;
    is_active: boolean;
    created_at: Date;
    updated_at: Date;
}

export interface GetCalculationsResponse {
    calculations: Calculation[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

export interface PatientCalculationResponse {
    calculation_name: string;
    chart_type: string;
    calculation_details: string;
    calculated_date: string;
    data: {
        calculated_value: number;
    };
}

export type ViewMode = 'card' | 'table';
export type TableSortOrder = 'ascend' | 'descend';
export enum TabOption {
    CLINICAL_MEASURES = 'Clinical Measures',
    PATIENT_METRICS = 'Patient Metrics',
}
export enum SortOption {
    NAME_ASC = 'Name Ascending',
    NAME_DESC = 'Name Descending',
    CATEGORY = 'Category',
}

export interface FilterState {
    category: string[];
    subscriptionType?: string[];
    platform?: string[];
}

export interface CategoryConfig {
    label: string;
    value: string;
    textColor: string;
    bgColor: string;
}

export type SortDirection = 'asc' | 'desc';
export type SortField = 'name' | 'category' | 'default';

export interface CalculationsUIState {
    activeTab: TabOption;
    viewMode: ViewMode;

    calculationsTab: {
        selectedCategories: string[];
        categoriesInitialized: boolean;
        searchValue: string;
        sortValue: string;
        currentPage: number;
        pageSize: number;
    };

    metricsTab: {
        selectedMetrics: number[];
        selectedCohort: {
            id: string;
            label: string;
        };
        searchValue: string;
        sortField?: string;
        sortOrder?: TableSortOrder;
        currentPage: number;
        pageSize: number;
    };

    detailsModal: {
        selectedCohort: {
            id: string;
            label: string;
        };
    };
}
